/**
 * Loading Skeleton
 * Skeleton placeholder for loading states
 */

import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface LoadingSkeletonProps {
  className?: string;
  lines?: number;
}

export function LoadingSkeleton({ className, lines = 3 }: LoadingSkeletonProps) {
  return (
    <Card className={className}>
      <CardHeader className="pb-2">
        <div className="h-4 w-24 animate-pulse rounded bg-muted" />
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {Array.from({ length: lines }).map((_, i) => (
            <div
              key={i}
              className={cn('h-3 animate-pulse rounded bg-muted', i === lines - 1 && 'w-3/4')}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
